// extracted by mini-css-extract-plugin
export default {"wrapper":"zJTTu9","withIcons":"LPP_D4","ltr":"_DRBYj","user":"OoN3ib","rtl":"PaFWup","name":"MseJE2","arrow":"WV9zK9"};